import React from 'react';
import {Link} from 'react-router-dom';
import {TRIAL_DAYS, TRIAL_PRICE_USD} from '../../domain/plans';

interface HeroProps {
    isAuthenticated: boolean;
}

const Hero: React.FC<HeroProps> = ({isAuthenticated}) => {
  return (
    <section className="bg-gradient-to-b from-gray-800 to-gray-900 py-20 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold tracking-tight text-white sm:text-6xl">
                            Auto-Edit Your
              <span className="block text-primary-400">Timeline</span>
            </h1>

            <p className="mt-6 text-lg text-gray-400">
                            Upload your footage → we cut out filler words &amp; profanity, and deliver a clean,
                            ready-to-tweak timeline straight into Premiere Pro, DaVinci Resolve, or Final Cut Pro.
            </p>

            <p className="mt-2 text-sm text-gray-500">
                            From raw audio to finished timeline in minutes.
            </p>

            <p className="mt-2 text-sm text-gray-500">
                            Try the {TRIAL_DAYS}-day trial for ${TRIAL_PRICE_USD}, cancel any time.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
              <Link
                to={isAuthenticated ? '/welcome' : '/signup'}
                className="flex items-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-white hover:bg-primary-700 transition-colors font-medium"
              >
                {isAuthenticated ? 'Open the app' : 'Start your trial'}
                <span>→</span>
              </Link>

              {/* The desktop build is retired — the secondary CTA now points at the app itself. */}
              <Link
                to={isAuthenticated ? '/projects' : '/login'}
                className="rounded-md bg-primary-500 px-6 py-3 text-white hover:bg-primary-600 transition-colors font-medium"
              >
                {isAuthenticated ? 'My Projects' : 'Sign In'}
              </Link>
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src="/censorme-hush-splash.png"
              alt="CensorMe Character"
              className="w-full max-w-sm h-auto border-b-8 border-gray-700"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
